const values = {
    "ADDITIONAL_PRICES": "Precios adicionales",
    "NO_ADDITIONAL_PRICES": "No hay precios adicionales!!!",
}

export default values;